import * as Yup from "yup";

export const dataModel = {
  month: "",
  year: "",
  employeeID: "",
  employeeCode:"",
  employeeName: "",
};

export const validationDataModel = Yup.object().shape({
  month: Yup.number().optional(""),
  year: Yup.number().optional(""),
  employeeID: Yup.number().optional(""),
  employeeName: Yup.string().optional(""),
  employeeCode: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
